import fetchAPI from '../../../lib/utils/fetch-api'

export async function getDomains() {
  return fetchAPI('/api/dealers/admin/domains')
}

export async function getControlPlaneMeta() {
  return fetchAPI('/api/dealers/admin/meta')
}

export async function checkDomain(hostname: string) {
  return fetchAPI(`/api/dealers/admin/domains/check?hostname=${encodeURIComponent(hostname)}`)
}

export async function activateDomain(hostname: string) {
  return fetchAPI('/api/dealers/admin/domains/activate', {
    method: 'POST',
    body: JSON.stringify({ hostname }),
  })
}

export async function deactivateDomain(hostname: string) {
  return fetchAPI('/api/dealers/admin/domains/deactivate', {
    method: 'POST',
    body: JSON.stringify({ hostname }),
  })
}

export async function deleteTenant(hostname: string) {
  return fetchAPI('/api/dealers/admin/domains/delete-tenant', {
    method: 'POST',
    body: JSON.stringify({ hostname }),
  })
}

export async function releaseDomain(hostname: string) {
  return fetchAPI('/api/dealers/admin/domains/release', {
    method: 'POST',
    body: JSON.stringify({ hostname }),
  })
}

export async function getProvisionJobs() {
  return fetchAPI('/api/dealers/admin/domains/provisioning/jobs')
}

export async function createOnboardJob(payload: Record<string, unknown>) {
  return fetchAPI('/api/dealers/admin/domains/provisioning/onboard', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function runProvisionJob(jobId: string, payload: { force?: boolean } = {}) {
  return fetchAPI(`/api/dealers/admin/domains/provisioning/jobs/${jobId}/run`, {
    method: 'POST',
    body: JSON.stringify(payload || {}),
  })
}

export async function getTenantById(tenantId: string) {
  return fetchAPI(`/api/dealers/admin/domains/tenant/${tenantId}`)
}

export async function getRegistrationLink(token: string) {
  return fetchAPI(`/api/dealers/public/registration-links/${encodeURIComponent(token)}`)
}

export async function getRegistrationProgress(token: string) {
  return fetchAPI(`/api/dealers/public/registration-links/${encodeURIComponent(token)}/progress`)
}

export async function getDemoRegistrationProgress(jobId: string) {
  return fetchAPI(`/api/dealers/public/demo-registrations/${encodeURIComponent(jobId)}/progress`)
}

export async function submitRegistrationLink(token: string, payload: Record<string, unknown>) {
  return fetchAPI(`/api/dealers/public/registration-links/${encodeURIComponent(token)}/submit`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function submitDemoRegistration(payload: Record<string, unknown>) {
  return fetchAPI('/api/dealers/public/demo-registrations', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function getPlatformModules() {
  return fetchAPI('/api/dealers/admin/modules')
}

export async function updatePlatformModule(code: string, payload: Record<string, unknown>) {
  return fetchAPI(`/api/dealers/admin/modules/${encodeURIComponent(code)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  })
}

export async function getPaymentVariants() {
  return fetchAPI('/api/dealers/admin/modules/payment-variants')
}

export async function upsertPaymentVariant(payload: Record<string, unknown>) {
  return fetchAPI('/api/dealers/admin/modules/payment-variants', {
    method: 'PUT',
    body: JSON.stringify(payload),
  })
}

export async function deletePaymentVariant(termMonths: number) {
  return fetchAPI(`/api/dealers/admin/modules/payment-variants/${termMonths}`, {
    method: 'DELETE',
  })
}

export async function getPlatformSetting(name: string) {
  return fetchAPI(`/api/dealers/admin/settings/${encodeURIComponent(name)}`)
}

export async function updatePlatformSetting(name: string, payload: Record<string, unknown>) {
  return fetchAPI(`/api/dealers/admin/settings/${encodeURIComponent(name)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  })
}

export async function testPlatformMail(to: string) {
  return fetchAPI('/api/dealers/admin/settings/mail/test', {
    method: 'POST',
    body: JSON.stringify({ to }),
  })
}

export async function getTenantModuleCatalog(tenantId: string) {
  return fetchAPI(`/api/dealers/admin/tenants/${tenantId}/modules/catalog`)
}

export async function previewTenantModuleActivation(
  tenantId: string,
  payload: { module_code: string; activation_mode: 'now' | 'next_period' },
) {
  return fetchAPI(`/api/dealers/admin/tenants/${tenantId}/modules/preview`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export async function activateTenantModule(
  tenantId: string,
  code: string,
  activationMode: 'now' | 'next_period',
) {
  return fetchAPI(
    `/api/dealers/admin/tenants/${tenantId}/modules/${encodeURIComponent(code)}/activate`,
    {
      method: 'POST',
      body: JSON.stringify({ activation_mode: activationMode }),
    },
  )
}

export async function deactivateTenantModule(tenantId: string, code: string) {
  return fetchAPI(
    `/api/dealers/admin/tenants/${tenantId}/modules/${encodeURIComponent(code)}/deactivate`,
    {
      method: 'POST',
      body: JSON.stringify({}),
    },
  )
}

export async function createTenantBillingPayment(
  tenantId: string,
  payload: Record<string, unknown>,
) {
  return fetchAPI(`/api/dealers/admin/tenants/${tenantId}/billing/payments`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}
